import { Tooltip } from "@/components/ui/tooltip";
import { TechnicianListEntity } from "@/pages/config/technicians/schema/technicians.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";

interface Props {
  item: TechnicianListEntity;
  handleDetail: (id: any) => void;
}

export const TechniciansActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Editar</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <PenLine
          cursor="pointer"
          onClick={() => handleDetail(item?.id)}
          data-testid="technicians-actions-edit"
        />
      </Flex>
    </Tooltip>
  );
};
